function createSeededRandom(seed) {
  function seededRandom() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed / 233280;
  }
  return seededRandom;
}

export function seededShuffle(array, seed) {
  const random = createSeededRandom(seed);
  let m = array.length;
  let t; let
    i;
  while (m) {
    i = Math.floor(random() * m);
    m -= 1;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }
  return array;
}

export function assignReviewsDates(reviews) {
  reviews.forEach((review, index) => {
    let messageDaysAgo;

    if (index === 0) {
      messageDaysAgo = 'today';
    }

    if (index === 1) {
      messageDaysAgo = '1 day ago';
    }

    if (index > 1 && index <= 3) {
      messageDaysAgo = '2 days ago';
    }

    if (index > 3 && index <= 5) {
      messageDaysAgo = '3 days ago';
    }

    if (index > 5 && index < 10) {
      messageDaysAgo = '3+ days ago';
    }

    if (index >= 10) {
      messageDaysAgo = '7+ days ago';
    }

    review.key = index;
    review.date = messageDaysAgo;
  });

  return reviews;
}
